<template>
  <div class="title">
    <div>
      <h2>{{ title }}</h2>
      <p>{{ vice }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "vice"],
};
</script>

<style scoped lang="scss" >
@media (min-width: 1200px) {
  .title {
    padding-left: 40px;
    > div {
      height: 74px;
      text-align: center;
      h2 {
        font-size: 28px;
        font-weight: normal;
        padding-top: 20px;
        text-align: center;
      }
      p {
        color: #ccc;
        font-size: 14px;
      }
    }
  }
}
@media (max-width: 1199px) {
  @import "../style/mb.scss";
  .title {
    > div {
      h2 {
        line-height: rm(40);
        font-size: rm(22);
        text-align: center;
        font-weight: 500;
      }
      p {
        color: #ccc;
        font-size: rm(16);
        text-align: center;
        margin: 0 0 rm(20);
      }
    }
  }
}
</style>